import React from 'react';
import Select from 'react-select';

export const nfSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '38px',
    borderRadius: '6px',
    borderColor: state.isFocused ? '#4a90d9' : '#ced4da',
    boxShadow: state.isFocused ? '0 0 0 0.15rem rgba(74, 144, 217, 0.25)' : 'none',
    '&:hover': {
      borderColor: state.isFocused ? '#4a90d9' : '#adb5bd',
    },
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    borderRadius: '6px',
    overflow: 'hidden',
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? '#4a90d9' : state.isFocused ? '#eef4fb' : '#fff',
    color: state.isSelected ? '#fff' : '#212529',
    cursor: 'pointer',
  }),
};

const filterProductOption = (option, inputValue) => {
  if (!inputValue) {
    return true;
  }
  return String(option.label || '')
    .toLowerCase()
    .includes(String(inputValue).toLowerCase());
};

const NfProductSearchSelect = ({
  inputId,
  options = [],
  value,
  onChange,
  placeholder = 'Type to search product...',
  hasError = false,
}) => {
  const selectedOption = value
    ? options.find((option) => String(option.value) === String(value)) ||
      { value, label: `Product #${value}` }
    : null;

  return (
    <Select
      inputId={inputId}
      className="nf-product-select"
      classNamePrefix="nf-select"
      options={options}
      value={selectedOption}
      onChange={(option) => onChange(option ? option.value : '')}
      isClearable
      isSearchable
      filterOption={filterProductOption}
      placeholder={placeholder}
      noOptionsMessage={() => 'No matching product found'}
      styles={{
        ...nfSelectStyles,
        control: (base, state) => ({
          ...nfSelectStyles.control(base, state),
          borderColor: hasError
            ? '#dc3545'
            : state.isFocused
              ? '#4a90d9'
              : '#ced4da',
        }),
      }}
      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
      menuPosition="fixed"
    />
  );
};

export default NfProductSearchSelect;

export const getProductOptionsForForm = (forms, formIndex, productList) => {
  const currentProductId = forms[formIndex]?.product_data;
  const usedByOtherForms = new Set(
    forms
      .map((form, index) =>
        index !== formIndex && form.product_data ? String(form.product_data) : null
      )
      .filter(Boolean)
  );

  return (productList || []).filter(
    (item) =>
      !usedByOtherForms.has(String(item.value)) ||
      String(item.value) === String(currentProductId)
  );
};
